import { acceptHMRUpdate, defineStore } from 'pinia'
import { ref } from 'vue'

import { index } from '@last/core'

import { couriersApi } from '@/api/client'
import type { Courier } from '@/types'

export const useCouriersStore = defineStore(
  'couriers',
  () => {
    const couriers = ref<Record<string, Courier>>({})

    async function refreshCouriers(inputCouriers?: Courier[]) {
      let updateCouriers = inputCouriers
      if (!updateCouriers) {
        updateCouriers = await couriersApi.getCouriers()
      }
      couriers.value = index(updateCouriers, 'id')
    }

    return {
      couriers,
      refreshCouriers
    }
  },
  {
    persist: true
  }
)

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useCouriersStore, import.meta.hot))
}
